import { useLanguage } from "../../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import { Button, Modal } from "@mantine/core";
import { IconBell, IconStar } from "@tabler/icons-react";
import NotificationContent from "./NotificationContent";

const NotificationSettings = ({ disabled }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      <Button
        variant="light"
        radius={"md"}
        leftSection={<IconBell size={20} />}
        w={"100%"}
        justify="start"
        onClick={open}
        disabled={disabled}
      >
        {lang.prm.notifications.button_label}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={lang.prm.notifications.title}
        size={"xl"}
      >
        <NotificationContent handleClose={close} />
      </Modal>
    </>
  );
};

export default NotificationSettings;
